import { useEffect } from "react"

import { useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { getOfferThunk } from "features/user/user-agreement/model/slice/userAgreementModalSlice"
import { selectUserAgreementTextContent } from "features/user/user-agreement/model/selectors/userAgreementSelectors"
import { Typography } from "antd"
import styled from "styled-components"

export const OfferPage = () => {
  const dispatch = useAppDispatch()
  const { offerId } = useParams()
  const textContent = useAppSelector(selectUserAgreementTextContent)

  useEffect(() => {
    if (!offerId) return

    dispatch(getOfferThunk(offerId))
  })

  return (
    <SContentContainer>
      <Typography.Text>
        <div dangerouslySetInnerHTML={{ __html: textContent }} />
      </Typography.Text>
    </SContentContainer>
  )
}

const SContentContainer = styled.div`
  padding: 20px;
`
